import axios from 'axios';
import Environment from '../../utils/Environment';

interface MandatoryFieldsResponse {
  mandatoryFields: string[];
}

const getMandatoryFieldsTable = async (
  orgCode: string,
  env: string,
  group: string,
  subGroup: string
): Promise<string[]> => {
  try {
    const baseURL = Environment.getMandatoryFieldsAPI();
    
    if (!baseURL) {
      console.warn('⚠️ Mandatory fields API URL not configured');
      return [];
    }
    
    if (!orgCode || !group || !subGroup) {
      console.warn('⚠️ Missing required parameters for mandatory fields API');
      return [];
    }
    
    const apiURL = `${baseURL}?dcCode=${encodeURIComponent(orgCode)}&group=${encodeURIComponent(group)}&sub=${encodeURIComponent(subGroup)}`;
    
    const response = await axios.get<MandatoryFieldsResponse>(apiURL);
    
    // Return the mandatory fields array from response
    if (response.data && Array.isArray(response.data.mandatoryFields)) {
      return response.data.mandatoryFields;
    } else if (Array.isArray(response.data)) {
      // Handle case where API returns array directly
      return response.data;
    }
    
    return [];
  } catch (err: any) {
     if (err.response) {
    }
    return [];
  }
};

export default getMandatoryFieldsTable;
